import { render, staticRenderFns } from "./OpenEndedLayout.vue?vue&type=template&id=1da022db&scoped=true&"
import script from "./OpenEndedLayout.vue?vue&type=script&lang=js&"
export * from "./OpenEndedLayout.vue?vue&type=script&lang=js&"
import style0 from "./OpenEndedLayout.vue?vue&type=style&index=0&id=1da022db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da022db",
  null
  
)

export default component.exports